<footer class="footer-container mt-4" *ngIf="isComponentVisible()">
    <div class="col-12 text-center mt-1 mb-3">
        Grupo Moura © 2020 - Todos os Direitos Reservados
    </div>
</footer>
